import React from 'react';

const CustomButton = ({ children, onClick, disable }) => {
  return (
    <a
      href=""
      className="govuk-link"
      onClick={(e) => {
        e.preventDefault();
        if (!disable) {
          onClick();
        }
      }}
      style={{
        color: '#1F70B8',
        fontSize: '20px',
        cursor: disable ? 'not-allowed' : 'pointer',
        // pointerEvents: disable ? 'none' : 'all',
      }}
    >
      {children}
    </a>
  );
};

export default CustomButton;
